import {
  ModeratorRoutesPrivileges,
  StaffManagerPermissions
} from "modules/common";

export * from "./enums";

export const STAFF_MANAGER_PRIVILEGES_LIST = [
  { label: "Dashboard", value: ModeratorRoutesPrivileges.Dashboard },
  { label: "Marketing", value: ModeratorRoutesPrivileges.Marketing },
  {
    label: "Users",
    value: ModeratorRoutesPrivileges.Resellers,
    nestedOptions: [
      {
        label: "Block Resellers",
        value: StaffManagerPermissions.BlockResellers
      },
      {
        label: "Unblock Resellers",
        value: StaffManagerPermissions.UnblockResellers
      },
      {
        label: "Delete Resellers",
        value: StaffManagerPermissions.DeleteResellers
      },
      {
        label: "Restore Resellers",
        value: StaffManagerPermissions.RestoreResellers
      }
    ]
  },
  { label: "Categories", value: ModeratorRoutesPrivileges.Categories },
  { label: "Orders", value: ModeratorRoutesPrivileges.Orders },
  { label: "Returns", value: ModeratorRoutesPrivileges.Returns },
  {
    label: "Products",
    value: ModeratorRoutesPrivileges.Products,
    nestedOptions: [
      {
        label: "Create Products",
        value: StaffManagerPermissions.CreateProducts
      },
      {
        label: "Update Products",
        value: StaffManagerPermissions.UpdateProducts
      },
      {
        label: "Delete Product Variants",
        value: StaffManagerPermissions.DeleteProductVariants
      },
      {
        label: "Change Product Variant Visibility for Resellers",
        value:
          StaffManagerPermissions.ChangeProductVariantVisibilityForResellers
      }
    ]
  },
  { label: "Product Sets", value: ModeratorRoutesPrivileges.ProductSets },
  { label: "Special Offers", value: ModeratorRoutesPrivileges.SpecialOffers },
  { label: "Banners", value: ModeratorRoutesPrivileges.Banners },
  { label: "Coupons", value: ModeratorRoutesPrivileges.Coupons },
  {
    label: "Sharing Schedule",
    value: ModeratorRoutesPrivileges.SharingSchedule
  },
  { label: "Insights", value: ModeratorRoutesPrivileges.Insights },
  { label: "Inventory", value: ModeratorRoutesPrivileges.Inventory },
  { label: "Financial", value: ModeratorRoutesPrivileges.Financial },
  { label: "Notification", value: ModeratorRoutesPrivileges.Notification },
  { label: "Verification", value: ModeratorRoutesPrivileges.Verification },
  { label: "Drivers", value: ModeratorRoutesPrivileges.Drivers },
  { label: "Content", value: ModeratorRoutesPrivileges.Content },
  {
    label: "Staff Management",
    value: ModeratorRoutesPrivileges.StaffManagement
  },
  {
    label: "AI Assistants",
    value: ModeratorRoutesPrivileges.AiAssistants,
    nestedOptions: [
      {
        label: "Manage AI Lessons",
        value: StaffManagerPermissions.ManageAiLessons
      }
    ]
  },
  { label: "Activity Log", value: ModeratorRoutesPrivileges.ActivityLog },
  {
    label: "Critical Alerts",
    value: ModeratorRoutesPrivileges.CriticalAlerts,
    nestedOptions: [
      {
        label: "Acknowledge Critical Alerts",
        value: StaffManagerPermissions.AcknowledgeAuditAlerts
      }
    ]
  },
  {
    label: "Email Notifications",
    value: ModeratorRoutesPrivileges.EmailNotifications,
    nestedOptions: [
      {
        label: "Manage Email Recipients",
        value: StaffManagerPermissions.ManageEmailNotificationRecipients
      }
    ]
  }
];
